import { Component, OnInit, Input } from '@angular/core';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'product-quantity',
  templateUrl: './product-quantity.component.html',
  styleUrls: ['./product-quantity.component.scss']
})
export class ProductQuantityComponent  {
  @Input('product') product;
  @Input ('shopping-cart') shoppingCart;

  stockAlert: boolean = false;
  constructor(private cartService : ShoppingCartService, private dataService : DataService) { }

  addToCart(){
    console.log("minimum:",this.shoppingCart)
    if(this.product.quantity >= this.product.stockQuantity && (!this.product.no_qty_limit)){
      this.stockAlert = true;
      setTimeout (() => {
        this.stockAlert = false;
     }, 2000);
    }else{
      this.stockAlert = false;
      this.cartService.add(this.product.id);
    }
  }

  removeFromCart(){
    this.cartService.reduce(this.product.id);
  }

  findProductInCart(){
    this.cartService.cartItems
  }
  


}
